module.exports = __webpack_public_path__ + "media/images/faramia/favicon-7c799c3355eaacd755d647abec67a9c3.png";